module.exports = __webpack_public_path__ + "img/nature-48.36ae64b2.jpg";